document.addEventListener('DOMContentLoaded', function() {
  var e = document.querySelector('.product_form');
  var hcSticky = document.querySelector('.product__information');
  var observer = new MutationObserver(function (event) {
    hcSticky.classList.toggle('hc-sticky');
  });
  
  observer.observe(e, {
    attributes: true, 
    attributeFilter: ['class'],
    childList: false, 
    characterData: false
  })

  const buttons = document.querySelectorAll(".benefits_inn");
  buttons.forEach(btn => {
    btn.addEventListener('click', function(event) {      
      if( btn.classList.contains("is_active") ){
        btn.classList.remove("is_active");
      }else{
        btn.classList.add("is_active");  
      }    
    });
  });
  
  const modal_btn = document.querySelector(".modal_btn");
  if( modal_btn ){
    modal_btn.addEventListener('click', function(e){
      manageButtonClass();
    })
  }
  

  const close_btn = document.querySelector(".close_icon");
  if( close_btn ){
    close_btn.addEventListener('click', function(e){
      manageButtonClass();
    })
  }
  
  function manageButtonClass(){
    const image_modal = document.querySelector(".image_modal")
    if( image_modal.classList.contains("is_open_modal") ){
      image_modal.classList.remove("is_open_modal")
      document.body.classList.remove('is_modal'); 
    }else{
      image_modal.classList.add("is_open_modal")
      document.body.classList.add('is_modal'); 
    }      
  }
});

